import { render, staticRenderFns } from "./LocaleSwitcher.vue?vue&type=template&id=462e1f69&"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js&"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports